import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'

// clipboard
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
